import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import { searchBox, stats, configure, sortBy } from 'instantsearch.js/es/widgets';
import customHits from './algolia/hits';
import customPagination from './algolia/pagination';
import customRefinementList from './algolia/refinementList';
import { 
    getCustomRouter, 
    getApiIdentifiant, 
    getFiltres, 
    getSearchFiltres
} from './../../../algolia/helper';

// Récupération des données nécessaires à Algolia
let apiIdentifiant = getApiIdentifiant();
let filtres = getFiltres(); // Récupération des filtres en JSON
let formattedFiltres = formatFiltres(filtres); // Transformation du JSON en format de requête Filters Algolia
let traductions = getTraductions();
let indexName = getAlgoliaIndex();

const searchClient = algoliasearch(apiIdentifiant.appId, apiIdentifiant.apiId);
const search = instantsearch({
    indexName,
    searchClient,
    routing: getCustomRouter(indexName, getInitialUiState()),
});
let widgetParameters = [
    configure({
        filters: formattedFiltres.length > 1 ? formattedFiltres.concat(" ", "AND particulier=1 AND marque_particulier=1") : formattedFiltres.concat("particulier=1 AND marque_particulier=1"),
    }),
    sortBy({
        container: ".sort-products",
        items: [
            {label: traductions.sort.default, value: indexName},
            {label: traductions.sort.date_publication_asc, value: getAlgoliaIndexDatePublicationAsc()},
            {label: traductions.sort.date_publication_desc, value: getAlgoliaIndexDatePublicationDesc()},
        ],
    }),
    searchBox({
        container: '.barreRecherche',
        placeholder: traductions.searchPlaceholder,
        showSubmit: false,
        cssClasses: {
            // root: "container",
            form: "barreRecherche-interne form-group",
            input: "form-control form-control-lg"
        }
    }),
    customHits({
        container: document.querySelector('#algolia_result'),
        traductions: traductions,
        transformItems: (items) => transformItems(items)
    }),
    customPagination({
        container: document.querySelector('#pagination_produit'),
        scrollTo: document.querySelector('header')
    }),
    stats({
        container: '.tematik_produits-compteur',
        templates: {
            text: `
                {{#hasNoResults}}${traductions.stats.none}{{/hasNoResults}}
                {{#hasOneResult}}${traductions.stats.one}{{/hasOneResult}}
                {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} ${traductions.stats.several}{{/hasManyResults}}
            `,
        },
    }),
    customRefinementList({
        container: document.querySelector('#content_gammes'),
        header: document.querySelector('#header_gammes'),
        filtres: filtres.gammes,
        attribute: 'gamme_produit',
    }),
    // customRefinementList({
    //     container: document.querySelector('#content_categories'),
    //     header: document.querySelector('#header_categories'),
    //     filtres: filtres.categories,
    //     attribute: 'categorie_produit',
    // }),
    customRefinementList({
        container: document.querySelector('#content_marques'),
        header: document.querySelector('#header_marques'),
        filtres: filtres.marques,
        attribute: 'marque',
    }),
    customRefinementList({
        container: document.querySelector('#content_modeDeVie'),
        header: document.querySelector('#header_modeDeVie'),
        filtres: filtres.modesConsommation,
        attribute: 'mode_de_consommation',
    })
];

search.addWidgets(widgetParameters);
search.start();


/**
 * Retourne le nom de l'index concerné pour la recherche en fonction de la langue de la page
 * @return string
 */
function getAlgoliaIndex()
{
    let langue = filtres.langue;

    if (langue === 'fr') {
        return 'produits_fr';
    }

    return 'produits_en';
}

function getAlgoliaIndexDatePublicationAsc() {
    let langue = filtres.langue;

    if (langue === 'fr') {
        return 'produits_date_publication_asc_fr';
    }

    return 'produits_date_publication_asc_en';
}

function getAlgoliaIndexDatePublicationDesc() {
    let langue = filtres.langue;

    if (langue === 'fr') {
        return 'produits_date_publication_desc_fr';
    }

    return 'produits_date_publication_desc_en';
}

function getInitialUiState()
{
    let { searchInput, gamme, mode_consommation, marques } = getSearchFiltres();

    if (marques) {
        marques = marques.toUpperCase()
    } else {
        marques = "";
    }
    
    let index = getAlgoliaIndex();

    if (!searchInput && !gamme && !mode_consommation && !marques) {
        return {[index]: {}};
    }
    
    let state = {
        [index]: {
            query: searchInput,
            gamme_produit: gamme ? [gamme] : [],
            mode_de_consommation: mode_consommation ? [mode_consommation] : [],
            marque: marques ? [marques] : [],
        }
    }
    return state;
}

/**
 * Transforme un item et le retourne transformé
 * @param items 
 * @return newItem
 */
function transformItems(items)
{
    return items.map((item) => {
        let newItem = item;
        // on met le code article en minuscule pour l'url
        newItem.code_article = newItem.code_article ? newItem.code_article.toLowerCase() : "";
        newItem.code_article_uvc = newItem.code_article_uvc ? newItem.code_article_uvc.toLowerCase() : "";
        // Traitement url, image path...
        return newItem;
    });
}



/**
 * Retourne les traductions nécessaires pour l'affichages du bloc
 * @return object traductions
 */
function getTraductions()
{
    let traductions = $('.tematik_produits').data('traductions');
    return traductions;
}

/**
 * Transforme les filtres sous la forme de query filters Algolia
 * @param filtres 
 * @return string formattedFiltres
 */
function formatFiltres(filtres)
{
    let rawTab = [];
    if (filtres.gammes) {
        let filtresGamme = formatFiltresByFacet(filtres.gammes, 'gamme_produit');
        if (filtresGamme.length > 0) {
            rawTab.push(filtresGamme);
        }
    }
    if (filtres.categories) {
        let filtresCategorie = formatFiltresByFacet(filtres.categories, 'categorie_produit');
        if (filtresCategorie.length > 0) {
            rawTab.push(filtresCategorie);
        }
    }
    if (filtres.marques) {
        let filtresMarque = formatFiltresByFacet(filtres.marques, 'marque');
        if (filtresMarque.length > 0) {
            rawTab.push(filtresMarque);
        }
    }
    if (filtres.modesConsommation) {
        let filtresModeConsommation = formatFiltresByFacet(filtres.modesConsommation, 'mode_de_consommation');
        if (filtresModeConsommation.length > 0) {
            rawTab.push(filtresModeConsommation);
        }
    }

    let formattedFiltres = rawTab.join(' AND ');

    return formattedFiltres;
}

/**
 * Formatte les filtres par attributs Algolia
 * @param filtres 
 * @param facetName 
 * @return string formattedFiltres
 */
function formatFiltresByFacet(filtres, facetName)
{
    if (filtres.length === 0) {
        return "";
    }
    let algoliaFiltres = [];
    filtres.forEach((filtre, index) => {
        if(filtre.indexOf("'") >= 0) {
            let echap = '\\';
            let position = filtre.indexOf("'");
            filtre = [filtre.slice(0, position), echap, filtre.slice(position)].join('');
        }
        if(filtre.indexOf(' ') >= 0){
            algoliaFiltres.push(`${facetName.concat(':', ("'" + filtre + "'"))}`);
        } else {
            algoliaFiltres.push(facetName.concat(':', filtre));
        }
    });
    let formattedFiltres = algoliaFiltres.join(' OR ');

    return formattedFiltres;
}